
import VariantListItem from './VariantListItem'

export default {
  name: 'VariantList',
  components: {
    VariantListItem
  },
  props: {
    product: {
      type: Object,
      default: null
    },
    compact: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      activeVariant: null
    }
  },
  computed: {
    hasVariants() {
      return this.product && this.product.variantsCount > 0
    }
  },
  methods: {
    setVariant(variant) {
      this.activeVariant = variant
      this.$emit('set-variant', variant)
    },
    isFirst(index) {
      return index == 0
    },
    isLast(index) {
      return index + 1 == this.product.variants.length
    }
  },
  created() {
    if (this.hasVariants) {
      this.setVariant(this.product.variants[0])
    }
  },
  mounted() {
    const valid = (item) => item.totalOnHand > 0 || this.product.backorderable

    if (this.hasVariants && !valid(this.activeVariant)) {
      const active = this.product.variants.find(valid)
      active && this.setVariant(active)
    }
  }
}
